import type { PlacementBox } from './mineCartPlacement';
/** Les tailles utilisent le même arrondi que le renderer, injectable pour l’aperçu. */
export function coursePoursuitePlacement(
  layout: PlacementBox[],
  width: number,
  height: number,
  responsiveSize = (base: number) => Math.max(1, Math.round((base * Math.min(width, height)) / 455))
) {
  const box = (name: string) => layout.find(b => b.name === name);
  const finish = box('race_finish');
  const actor = (name: string, defaultSize: number) => {
    const track = box(`${name}_track`)!;
    const sizeBox = box(`${name}_sprite`);
    const size = responsiveSize(sizeBox ? (sizeBox.hPct / 100) * 455 : defaultSize);
    const end = box(`${name}_end`);
    const startX = (track.xPct / 100) * width;
    const feetY = ((track.yPct + track.hPct) / 100) * height;
    const dx = Math.max(0, ((end?.xPct ?? finish?.xPct ?? 84.5) / 100) * width - startX - size);
    const dy = end ? (end.yPct / 100) * height - feetY : 0;
    return { size, startX, feetY, dx, dy };
  };
  return { player: actor('player', 150), rival: actor('rival', 120) };
}
